import { ApiClient } from './core/ApiClient';

export interface InvoiceLineItem {
    description: string | null;
    quantity: number | null;
    unit_price: number | null;
    amount: number | null;
    sku: string | null;
}

export interface ExtractedInvoice {
    supplier_name: string | null;
    supplier_tax_id: string | null;
    invoice_number: string | null;
    invoice_date: string | null;
    due_date: string | null;
    purchase_order: string | null;
    currency: string | null;
    subtotal: number | null;
    tax: number | null;
    total: number | null;
    line_items: InvoiceLineItem[];
}

export interface InvoiceValidationIssue {
    code: string;
    message: string;
    severity: string;
}

export interface InvoiceExtractionResult {
    status: string;
    provider_used: string | null;
    invoice: ExtractedInvoice;
    validation: {
        confidence: number;
        issues: InvoiceValidationIssue[];
    };
    trace: {
        ocr_provider: string | null;
        extractor_provider: string | null;
        template_id: string | null;
        elapsed_ms: number | null;
        details: Record<string, unknown>;
    };
}

const invoiceClient = new ApiClient('https://invoice.peregin.com');
const root = '/invoices';

export const extractInvoice = (file: File): Promise<InvoiceExtractionResult> => {
    const formData = new FormData();
    formData.append('file', file);

    return invoiceClient.upload<InvoiceExtractionResult>(root, formData)
        .then(response => response.data)
        .catch(error => invoiceClient.handleError<InvoiceExtractionResult>(error));
};

export const invoiceExtractionService = { extract: extractInvoice };
